import React, { useEffect, useState } from "react";
import Head from "next/head";
import { Col, Container, Row } from "react-bootstrap";
import webBanner from "../public/images/page_banner/earth_day_web.png";
import mobBanner from "../public/images/page_banner/earth_day_mob.png";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const Earthday = () => {
  const [toggle, setToggle] = useState(false);
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
    Hash: false,
  });

  return (
    <>
      <Head>
        <title>
          Earth Day in New Kolkata - Apartment in Serampore, Hooghly
        </title>
        <meta
          name="description"
          content="On 22nd April, New Kolkata, the river facing township on the bank of river Hooghly had invited its Green Habitants to make the Earth Day event fruitful. The event was full of Healthy Discussions, fun activities and discussion on segregating waste to lead hygienic life style."
        />
        <meta
          name="keywords"
          content="ready to move in apartment, ready to move flats, flats in Serampore, flats in North Kolkata"
        />
      </Head>
      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />

            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section className="sec-padd">
        <Container>
          <div
            className="inner_text "
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="1000"
          >
            <p>
              On this Earth Day, New Kolkata had welcomed its Green Habitants to
              be a part of a very special event. On 22nd April, the members of
              the Green Habitant community were invited for the purpose of
              educating them about the importance of dry waste versus wet waste
              all other micro activties to promote greenery in their new homes.
              Apart from that, the visitors were instructed to bring an empty
              shoe box with which they took the step to build houses for the
              birds and provide shelter to them.
            </p>
            <p className="mb-0">
              Plus, they educated the buyers about segregating waste that will
              eventually promote a clean and hygienic environment. For example,
              the visitors were advised to use reusable water bottles that will
              reduce the use of 167 plastic water bottles approximately. The
              event ended on a good note with a plethora of delicious food, fun
              activities, and healthy discussion about embracing greenery and
              upgrading the environment. Come have a look at the event coverage
              here!
            </p>
          </div>
        </Container>
      </section>
      <section className="gallery">
        <Container fluid={true}>
          <div className="head_wrap text-center">
            <div className="center-title">
              <h2
                className="section-title"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1000"
              >
                <span>Image Gallery</span>
              </h2>
            </div>
          </div>
          <Swiper
            modules={[Autoplay, Navigation]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: ".cust-swiper-button-next",
              prevEl: ".cust-swiper-button-prev",
            }}
            loop={true}
            speed={1200}
            className="cust_slider"
            breakpoints={{
              767: {
                slidesPerView: 1,
                spaceBetween: 24,
              },
              992: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
          >
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_0233.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_0233.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_0296.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_0296.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_0330.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_0330.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_0351.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_0351.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_0364.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_0364.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_8986.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_8986.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_8993.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_8993.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_8999.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_8999.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_9150.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_9150.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_9191.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_9191.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/IMG_9205.JPG"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/IMG_9205.JPG"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img01.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img01.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img03.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img03.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img04.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img04.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img05.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img05.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img06.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img06.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img07.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img07.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img09.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img09.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img10.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img10.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img11.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img11.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img12.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img12.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img13.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img13.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img15.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img15.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img16.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img16.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img17.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img17.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img18.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img18.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img19.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img19.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img20.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img20.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img21.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img21.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img22.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img22.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img23.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img23.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img24.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img24.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img25.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img25.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img26.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img26.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img27.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img27.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img28.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img28.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img30.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img30.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-src="/images/green_habitant/earth_day/img31.jpg"
                  className="img_overlay"
                  data-fancybox="habitant"
                >
                  <Image
                    fill
                    className="image"
                    alt="earth day"
                    src="/images/green_habitant/earth_day/img31.jpg"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <div className="swiper-nav mt-4">
              <button className="fa-solid fa-chevron-left cust-swiper-button-prev">
                <span>prev</span>
              </button>
              <button className="fa-solid fa-chevron-right cust-swiper-button-next">
                <span>next</span>
              </button>
            </div>
          </Swiper>
        </Container>
        <Container>
          <div className="mt-3 mt-md-5">
            <div className="head_wrap text-center">
              <div className="center-title">
                <h2
                  className="section-title"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1000"
                >
                  <span>Video Gallery</span>
                </h2>
              </div>
            </div>
            <Row className="justify-content-center">
              <Col md={8}>
                <div className="video">
                  <div className="img-wrap image-container gall_wrp">
                    <div
                      data-fancybox="video"
                      data-src="https://www.youtube.com/embed/phP1RZBaZYY"
                      className="img_overlay"
                    >
                      <Image
                        fill
                        src="/images/green_habitant/earth_day/video_thumb.jpg"
                        alt="plant_tree"
                        className="image"
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="sec-padd water_mark">
        <Container>
          <div className="head_wrap text-center">
            <div className="center-title">
              <h2
                className="section-title"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1000"
              >
                <span>In the News</span>
              </h2>
            </div>
          </div>
          <ul className="press-release-list">
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="press"
                  src="/images/green_habitant/earth_day/img01.jpg"
                />
              </div>
              <div className="press-details">
                <h4>Alcove Affordable Homes in Serampore, Hooghly</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>May 8, 2018</span>
                </div>
                <p>
                  Mother Earth, where we all live in and you can’t get through a
                  single day without having an impact on the world around you.
                </p>
                <a
                  className="read-more"
                  href="http://www.priyapriyambada.com/alcove-new-kolkata-experience-the-magic-of-living-in-serampore-hoogly/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="press"
                  src="/images/green_habitant/earth_day/img02.jpg"
                />
              </div>
              <div className="press-details">
                <h4>Trip to New Kolkata</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>May, 08 2018</span>
                </div>
                <p>
                  Being a hard core traveller I am always in search of good
                  places and last week on Earth Day I got a chance to visit a
                  place which was like a nature’s bed for me.
                </p>
                <a
                  className="read-more"
                  href="http://amajesticmind.com/2018/05/08/trip-to-new-kolkata/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="press"
                  src="/images/green_habitant/earth_day/img03.jpg"
                />
              </div>
              <div className="press-details">
                <h4>Flats in New Kolkata | New Kolkata</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>April 27, 2018</span>
                </div>
                <p>
                  Hi folks! I hope you’re all doing great. This blog is
                  especially for the people who are really looking forward to
                  move to Kolkata, the city of joy.
                </p>
                <a
                  className="read-more"
                  href="http://www.sudeshnasworld.com/flats-in-new-kolkata-new-kolkata/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="press"
                  src="/images/green_habitant/earth_day/img04.jpg"
                />
              </div>
              <div className="press-details">
                <h4>
                  New Kolkata project : Affordable Housing within 30 lakhs
                </h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>May 8, 2018</span>
                </div>
                <p>
                  The talk of the town at the moment is the New City in the
                  making – New Kolkata. New Kolkata’s uniqueness has been
                  defined
                </p>
                <a
                  className="read-more"
                  href="https://theorangeepistles.wordpress.com/2018/05/08/new-kolkata-blog-two/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="press"
                  src="/images/green_habitant/earth_day/img05.jpg"
                />
              </div>
              <div className="press-details">
                <h4>The future of real estate: New Kolkata</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>May 8, 2018</span>
                </div>
                <p>
                  Whether you are married or single, a student or working, in
                  your mid 20s or late 60s; whoever you might be,
                </p>
                <a
                  className="read-more"
                  href="http://www.debasrideb.com/future-real-estate-new-kolkata/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="press"
                  src="/images/green_habitant/earth_day/img06.jpg"
                />
              </div>
              <div className="press-details">
                <h4>New Kolkata – The New #UrbanGreen in Town</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>MAY 7, 2018</span>
                </div>
                <p>
                  So recently I was cordially invited to New Kolkata to
                  celebrate World Earth Day. Well, let me tell you guys what New
                  Kolkata actually is.
                </p>
                <a
                  className="read-more"
                  href="http://www.thecelfieprincess.com/2018/05/07/new-kolkata-the-new-urbangreen-in-town/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
          </ul>
        </Container>
      </section>
    </>
  );
};

export default Earthday;
